import { Edit as EditContact } from './Edit';

export default EditContact;
